import { useState } from 'react';

interface BilingualFieldProps {
  label: string;
  valueEn: string;
  valueId: string;
  onChange: (lang: 'en' | 'id', value: string) => void;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
  placeholder?: string;
}

export function BilingualField({ label, valueEn, valueId, onChange, required, multiline, rows = 3, placeholder }: BilingualFieldProps) {
  const [activeLang, setActiveLang] = useState<'en' | 'id'>('id');
  const value = activeLang === 'en' ? valueEn : valueId;
  const otherValue = activeLang === 'en' ? valueId : valueEn;
  const otherLang = activeLang === 'en' ? 'ID' : 'EN';
  const hasOtherValue = otherValue.trim().length > 0;

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <label className="block text-sm font-medium text-gray-700">
          {label} {required && '*'}
        </label>
        <div className="flex gap-1">
          <button
            type="button"
            onClick={() => setActiveLang('id')}
            className={`px-2 py-0.5 text-xs rounded font-medium ${activeLang === 'id' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}
          >
            ID
          </button>
          <button
            type="button"
            onClick={() => setActiveLang('en')}
            className={`px-2 py-0.5 text-xs rounded font-medium ${activeLang === 'en' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}
          >
            EN
          </button>
        </div>
      </div>
      {multiline ? (
        <textarea
          value={value}
          onChange={(e) => onChange(activeLang, e.target.value)}
          rows={rows}
          required={required && activeLang === 'id'}
          placeholder={placeholder || `${label} (${activeLang.toUpperCase()})`}
          className="w-full border rounded-lg px-3 py-2 text-sm"
        />
      ) : (
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(activeLang, e.target.value)}
          required={required && activeLang === 'id'}
          placeholder={placeholder || `${label} (${activeLang.toUpperCase()})`}
          className="w-full border rounded-lg px-3 py-2 text-sm"
        />
      )}
      {!hasOtherValue && value.trim().length > 0 && (
        <p className="text-xs text-amber-600 mt-0.5">{otherLang} translation is empty</p>
      )}
    </div>
  );
}
